export default __webpack_public_path__ + "static/website-cover-3acaceb671a8ac8d51db10293b3b5c12.png";